import getAllWidgetsOnPage from './getAllWidgetsOnPage';
/**
 * Load any resources that need to be loaded before switching to a page
 * @param website the site editor website object
 * @param pageId id of the page being switched to
 */
export default function loadPageResources(website, pageId, setLoading) {
  return async (dispatch, getState) => {
    const widgets = getAllWidgetsOnPage(website, pageId);
    if (widgets.length > 0 && setLoading) {
      dispatch(setLoading(true));
    }
    const factory = getState().widgetFactory;
    // Some site editors leaves widgetFactory empty.
    if (factory && factory.loadWidgetResources) {
      await dispatch(factory.loadWidgetResources(widgets));
    }
  };
}
